import { Component, Input, OnInit } from '@angular/core';

import { IWizardContentComponent } from '../../../wizard.content';
import { NavigationProvider } from '@nrwl/navigation-abstract';
import { SitesService } from '@nrwl/common-lib';

@Component({
  selector: 'site-create-results-html',
  templateUrl: './sites.create.results.template.html',
  providers: [],
  styleUrls: [
    '../../../wizard.button.style.scss',
    '../wizard.sites.style.scss',
    './sites.create.results.style.scss'
  ]
})
export class SitesCreateResultsHtmlComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() id: string;
  @Input() previousOutput: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  siteImagePath: string;
  errorMessageObj: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(
    private readonly navigator: NavigationProvider,
    private readonly sitesService: SitesService
  ) {}

  ngOnInit() {
    this.siteImagePath = 'images/site.svg';
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  isLoading(): any {
    return this.wizardCtrl.getWizardService().isLoading;
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestFailed(): any {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnErrorMessage(): any {
    return this.wizardCtrl.getWizardService().errorMessage;
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnMsgObj(): any {
    try {
      return JSON.parse(this.wizardCtrl.getWizardService().errorMessage);
    } catch (error) {
      // To fix failing JSON parse
      return false;
    }
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnMsgObjTitle(): any {
    const errObj = this.returnMsgObj();
    return errObj.title ? errObj.title.replace(/!/gi, '.') : '';
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnMsgObjContent(): any {
    const errObj = this.returnMsgObj();
    return errObj.content ? errObj.content : [];
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnSuccessMsgObj(): any {
    return this.wizardCtrl.getWizardService().successSiteList || false;
  }

  addAnotherSite(): void {
    this.wizardCtrl.toggleClose();
    setTimeout(() => {
      this.navigator.navigateToWizard(['add_sites']);
      this.sitesService.isManualMethodType.next(true);
    }, 100);
  }
}
